function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6 0a6 6 0 100 12A6 6 0 006 0zm.75 3.5a.749.749 0 11-1.499 0 .749.749 0 011.498 0zM6 5a.5.5 0 01.5.5v3a.5.5 0 01-1 0v-3A.5.5 0 016 5z",
  fill: "#8F90A6"
});

function SvgAdditionalInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgAdditionalInfoIcon;